import React, { useCallback, useContext } from 'react';
import { RemoveScroll } from 'react-remove-scroll';
import { TransitionProps } from '@material-ui/core/transitions';
import clsx from 'clsx';
import Fade from '@material-ui/core/Fade';

import { ButtonColour, ButtonStyle } from 'components/Button/constants';
import { ModalSize } from 'modules/modals/constants';
import { ReactComponent as MyAxelosSVG } from 'modules/theme/ims/MyAxelosBlue.svg';
import * as Button from 'components/Button';
import ModalOverlay from '../Overlay';
import PlatformContext from 'modules/platform/context';

import styles from './styles.module.scss';
import modalStyles from 'modules/modals/styles.module.scss';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement<any, any> },
  ref: React.Ref<unknown>,
) {
  return <Fade ref={ref} {...props} />;
});

export type ModalLapsedTemplateProps = {
  onClose: () => void;
  size?: ModalSize;
};

export const ModalLapsedUserTemplate = React.memo<ModalLapsedTemplateProps>(
  ({ onClose, size = ModalSize.FULLWIDTH }) => {
    const classNames = clsx(modalStyles[`${size}`], styles.modalLapsedUser);
    return (
      <section className={classNames} role="dialog">
        <div></div>
        <div>
          <div>
            <h1>Your MyAxelos subscription is Inactive.</h1>
            <p>Don't worry, you can renew it.</p>
          </div>
          <Button.CustomLink
            colour={ButtonColour.BRAND_BLACK_GRAPE}
            label="Renew subscription"
            onClick={onClose}
            style={ButtonStyle.SECONDARY}
            href={process.env.REACT_APP_NOROLE_URL!}
          />
        </div>
        <div>
          <MyAxelosSVG />
        </div>
      </section>
    );
  },
);

export type ModalLapsedUserProps = {
  destroyModal: () => void;
  disableRestoreFocus?: boolean;
  hideModal: () => void;
  id: string;
  onClose: () => void;
  open: boolean;
};

const LapsedUser: React.FunctionComponent<ModalLapsedUserProps> = ({
  destroyModal,
  disableRestoreFocus,
  hideModal,
  onClose,
  open,
}) => {
  const { isMobile } = useContext(PlatformContext);

  const handleClose = useCallback(() => {
    onClose ? open && onClose() : open && hideModal();
  }, [hideModal, onClose, open]);

  const handleKeyDown = useCallback(
    (event: React.KeyboardEvent) => {
      if (event.key === 'Escape' || event.key === 'Enter') {
        handleClose();
        event.preventDefault();
        event.stopPropagation();
      }
    },
    [handleClose],
  );
  return (
    <RemoveScroll enabled={isMobile}>
      <ModalOverlay
        disableRestoreFocus={disableRestoreFocus}
        onExited={destroyModal}
        onKeyDown={handleKeyDown}
        open={open}
        scroll="body"
        TransitionComponent={Transition}
      >
        <ModalLapsedUserTemplate onClose={handleClose} />
      </ModalOverlay>
    </RemoveScroll>
  );
};

export default LapsedUser;
